import { getMatchingPathPattern } from './utility'

export function setupAutoRefresh() {
    if (!window.noticeable.features.autoRefresh) {
        return
    }

    const matchingPathPattern = getMatchingPathPattern()
    if (matchingPathPattern !== '/' && !matchingPathPattern.startsWith('/publications/')) {
        return
    }

    let hidden, visibilityChange
    if (typeof document.hidden !== 'undefined') {
        hidden = 'hidden'
        visibilityChange = 'visibilitychange'
    } else if (typeof document['msHidden'] !== 'undefined') {
        hidden = 'msHidden'
        visibilityChange = 'msvisibilitychange'
    } else if (typeof document['webkitHidden'] !== 'undefined') {
        hidden = 'webkitHidden'
        visibilityChange = 'webkitvisibilitychange'
    }

    function handleVisibilityChange() {
        if (!document[hidden]) {
            window.location.reload()
        }
    }

    if (typeof document.addEventListener !== 'undefined' && hidden !== undefined) {
        document.addEventListener(visibilityChange, handleVisibilityChange, false)
    }
}
